import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "category", "document", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const title = this.titleTarget.value.trim().toLowerCase()
    const category = this.categoryTarget.value
    let visibleCount = 0

    this.documentTargets.forEach(document => {
      const matches = document.dataset.title.toLowerCase().includes(title) &&
        (!category || document.dataset.categoryId === category)
      document.style.display = matches ? "" : "none"
      if (matches) visibleCount++
    })

    this.emptyTarget.hidden = this.documentTargets.length === 0 || visibleCount > 0
  }
}
